import { render, staticRenderFns } from "./JWTLoginReturn.vue?vue&type=template&id=36923c58&scoped=true"
import script from "./JWTLoginReturn.vue?vue&type=script&lang=js"
export * from "./JWTLoginReturn.vue?vue&type=script&lang=js"
import style0 from "./JWTLoginReturn.vue?vue&type=style&index=0&id=36923c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36923c58",
  null
  
)

export default component.exports